import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
// import MenuItem from '@material-ui/core/MenuItem';
import { withRouter } from 'react-router-dom'
import { AddGroup, EditGroup, GetGroup } from '../../fetchs';

const useStyles = theme => ({
  appBar: {
    position: 'relative',
  },
  layout: {
    width: 'auto',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
      width: 600,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3),
    },
  },
  stepper: {
    padding: theme.spacing(3, 0, 5),
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  // textField: {
  //   marginLeft: theme.spacing(1),
  //   marginRight: theme.spacing(1),
  //   width: 200,
  // },
});

class Group extends Component {
  constructor(props){
    super(props);

    this.state = {
      groupId: '',
      name: '',
      loading: false,
      saving: false
    }
  }

  componentDidMount() {
    const groupId = this.props.match.params.groupId;
    if (groupId) {
        this.loadGroup(groupId);
    }
  }

  loadGroup = (groupId) => {
    this.setState({loading: true});
    GetGroup(groupId)
        .then(response => {
            this.setState({loading: false});
            return response.json();
        })
        .then(responseJson => {
            this.setState({ groupId: responseJson.groupId, name: responseJson.name });
        })
        .catch(error => {
            this.setState({loading: false});
            console.log(error);
        });
  }

  handleSave = () => {
      if(this.state.groupId)
        this.editGroup();
      else 
        this.addGroup();
  };

  addGroup = () => {
    AddGroup({
        name: this.state.name
      }).then(response => {
        if (response.status === 400) {
          console.log(response);
        } else if (response.status === 200) {
          this.props.history.push('/main/groups');
        }
        return response.json();
      }).then(responseJson => {
        console.log(responseJson.message);
      }).catch(error => {
        console.error(error);
      });
  }

  editGroup = () => {
    EditGroup(this.state.groupId, {
        name: this.state.name
      }).then(response => {
        if (response.status === 400) {
          console.log(response);
        } else if (response.status === 200) {
          this.props.history.push('/main/groups');
        }
        return response.json();
      }).then(responseJson => {
        console.log(responseJson.message);
      }).catch(error => {
        console.error(error);
      });
  }

  handleChange = name => event => {
    this.setState({ [name]: event.target.value });
  }

  render(){
    const { classes } = this.props;
    return (
      <React.Fragment>
        <CssBaseline />
        <main className={classes.layout}>
          <Paper className={classes.paper}>
            <Typography component="h1" variant="h4" align="center">
              افزودن گروه جدید
            </Typography>
            <React.Fragment>
              <form className={classes.container} noValidate autoComplete="off">
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <TextField
                        id="standard-name"
                        label="نام"
                        required
                        fullWidth
                        className={classes.textField}
                        value={this.state.name}
                        onChange={this.handleChange('name')}
                        margin="normal"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Button 
                    variant="contained" 
                    color="primary" 
                    fullWidth 
                    disabled={this.state.loading}
                    onClick={this.handleSave}>ذخیره</Button>
                  </Grid>
                </Grid>
              </form>
            </React.Fragment>
          </Paper>
        </main>
      </React.Fragment>
    )
  };
}

Group.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withRouter(withStyles(useStyles)(Group));
